/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

var configureglobals = new PageGlobals();

var controllerMode = {
    FIELD_CHANGE_QUOTE: 'FIELD_CHANGE_QUOTE',
    FULL_QUOTE: 'FULL_QUOTE'
};

var common = {
    offeringId: configureCommonGlobals.offeringId,
    getOfferingName: function () {
        var offering = configureglobals.coffering;
        if (offering == null) {
            return '';
        }
        return offering.name;
    },
    setCQuoteData: function (object, quoteInitMessages) {
        // stub quoteInitMessages into cquotedata object
        object.setProperty('requoteInitMessages', 'SerializedObject', quoteInitMessages);
        configureglobals.set('cquotedata', object);
        this.validation = new JobQuoteValidation(object.validation);
        var content = '';

        // show any global validation messages
        content += this.validation.generateGlobalMessages();

        // show any quote init messages
        if (quoteInitMessages && quoteInitMessages.list && quoteInitMessages.list.length > 0) {
            var ul = new JDUL({
                cssClass: 'validationInfoMessage'
            });
            for (var i = 0, ni = quoteInitMessages.list.length; i < ni; i++) {
                ul.add(quoteInitMessages.list[i].value);
            }
            content += ul.generate();
        }

        dynamic.setDivIdContent('validationMessagesDiv', content);
    },
    setCQuote: function (cquote) {
        configureglobals.set('cquote', cquote);

        if (configureglobals.cquote) {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, configureglobals.cquote);
        } else {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, {});
        }

        if (cquote == null) {
            dynamic.setDivIdContent('jobQuotePrices', '--');
        } else {
            var content = '';
            var table = new JDTable({
                cssClass: 'quote'
            });
            table.addRow([
                {
                    text: (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0 ? 'Original ' : 'Your ') + 'Price',
                    tag: 'th',
                    scope: 'row'
                },
                {
                    text: '<span class="lineItemPrice">$' + cquote.jobTotalPriceDisplay + '</span>'
                }
            ], {
                cssClass: 'productPrice'
            });
            if (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0) {
                if (cquote.offeringDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + cquote.offeringDiscountPercent + '% Savings',
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobOfferingDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount'
                    });
                }
                if (cquote.userDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + strWeb(cquote.userDiscountName),
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobUserDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount userDiscount'
                    });
                }
                table.addRow([
                    {
                        text: 'Your Price',
                        tag: 'th',
                        scope: 'row'
                    },
                    {
                        text: '<span class="lineItemPrice">$' + cquote.totalPriceDisplay + '</span>'
                    }
                ], {
                    cssClass: 'productPrice discounted'
                });
            }
            content += table.generate();
            dynamic.setDivIdContent('jobQuotePrices', content);
        }
    },
    efVals: {},
    ef: null,
    efFocus: function (fieldName, containerDivId, buttonDivId) {
        this.ef = fieldName;
        this.efVals[fieldName] = getFormItemValue(fieldName, document);
        dynamic.addClass(containerDivId, 'focus');
        $('a.deleteVersion', this).hide();
        dynamic.setDivIdContent(buttonDivId, forms.button('Update', {
            cssClass: 'secondary config',
            tabindex: '-1'
        }));
    },
    efBlur: function (fieldName, containerDivId, buttonDivId) {
        var previousValue = this.efVals[fieldName];
        dynamic.removeClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, '');
        var newValue = getFormItemValue(fieldName, document);
        if (previousValue != newValue) {
            var configChangeDetails = {
                context: 'efBlur',
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: previousValue,
                newValue: newValue
            };
            configureEvents.onCalcChanged(configChangeDetails);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            }, function () { // on failure reset to the previous value.
                setFieldValue(fieldName, previousValue, document);
            });
            this.ef = null;
        }
    },
    setOptionDiv: function (divId, content) {
        if (content == '') {
            dynamic.setClass(divId, 'optionWrapperEmpty');
        } else {
            dynamic.setClass(divId, 'optionWrapperOn');
        }
        dynamic.setDivIdContent(divId, content);
    },
    generateProofs: function () {
        var coffering = configureglobals.coffering;
        if (coffering.getPublishedShowProof()) {
            var fieldName = 'PROOFDD';
            var content = '';
            var error = this.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var cofferingproofs = coffering.getPublishedProofs();
            var cproofs = new Array();
            for (var i = 0; i < cofferingproofs.length; i++) {
                var cofferingproof = cofferingproofs[i];
                cproofs[cproofs.length] = cofferingproof.proof;
            }
            var selectedproof = configureglobals.cquotedata.proof;
            var help = '';

            // show system level proof tip if showTip is true at system product level
            if (coffering.systemOffering.showProofTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.coffering.systemOffering,\'proofTip\',\'' + TBGBOTip.PROOFS + '\')', {
                    id: 'proofTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (coffering.getPublishedEditProof()) {
                content += help + '<label class="config">Proof</label>';
                content += forms.dd(fieldName, cproofs, selectedproof, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'common.setProof()'
                });
                if (error) {
                    content += this.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedproof != null) {
                    content += help + '<label class="config">Proof</label>';
                    content += tags.div(selectedproof.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            this.setOptionDiv('proofsDiv', content);
        }
    },
    setProof: function () {
        var configChangeDetails = {
            context: 'setProof',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PROOFDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PROOFDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPROOF', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            var quote = cometRequest.getObject('STANDARDQUOTE');
            if (quote == null) {
                quote = cometRequest.getObject('LARGEQUOTE');
            }
            common.setCQuote(quote);
            growlMessages.showAll(cometRequest);
            common.generateProofs();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PROOFDD', false, document);
        cometRequest.send();
    },
    generateTurnaroundTimes: function () {
        var coffering = configureglobals.coffering;
        if (coffering.getPublishedShowTurnaroundTime()) {
            var fieldName = 'TURNAROUNDTIMEDD';
            var content = '';
            var error = this.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var cofferingturntimes = coffering.getPublishedTurnaroundTimes();
            var cturntimes = new Array();
            for (var i = 0; i < cofferingturntimes.length; i++) {
                var cofferingturntime = cofferingturntimes[i];
                cturntimes[cturntimes.length] = cofferingturntime.turnaroundTime;
            }
            var cselectedturnaroundtime = configureglobals.cquotedata.turnaroundTime;
            var help = '';

            // show system level turnaround tip if showTip is true at system product level
            if (coffering.systemOffering.showTurnaroundTimeTip) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.coffering.systemOffering,\'turnaroundTimeTip\',\'' + TBGBOTip.TURNAROUNDTIMES + '\')', {
                    id: 'turnaroundTimeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (coffering.getPublishedEditTurnaroundTime()) {
                content += help + '<label class="config">Production Time</label>';
                content += forms.dd(fieldName, cturntimes, cselectedturnaroundtime == null ? null : cselectedturnaroundtime, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'common.setTurnaroundTime()',
                    nameProperty: 'displayName'
                });
                if (error) {
                    content += this.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (cselectedturnaroundtime != null) {
                    content += help + '<label class="config">Production Time</label>';
                    content += tags.div(cselectedturnaroundtime.displayName, {
                        cssClass: 'noEdit'
                    });
                }
            }
            this.setOptionDiv('turnaroundTimesDiv', content);
        }
    },
    setTurnaroundTime: function () {
        var configChangeDetails = {
            context: 'setTurnaroundTime',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'TURNAROUNDTIMEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('TURNAROUNDTIMEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETTURNAROUNDTIME', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            var quote = cometRequest.getObject('STANDARDQUOTE');
            if (quote == null) {
                quote = cometRequest.getObject('LARGEQUOTE');
            }
            common.setCQuote(quote);
            growlMessages.showAll(cometRequest);
            common.generateTurnaroundTimes();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('TURNAROUNDTIMEDD', false, document);
        cometRequest.send();
    },
    generateAdditionalFields: function () {
        var coffering = configureglobals.coffering;
        var cofferingmetadata = coffering.metadata;
        var cquote = configureglobals.cquote;
        var cquoteadditionalfields = cquote == null ? null : cquote.additionalFields;
        var content = '';
        content += '<fieldset class="additionalInformation">';
        for (var i = 0, ni = cofferingmetadata ? cofferingmetadata.length : 0; i < ni; i++) {
            var acofferingmetadata = cofferingmetadata[i];
            var cquoteadditionalfieldsvalue = '';
            if (cquoteadditionalfields != null) {
                for (var propName in cquoteadditionalfields) {
                    var field = cquoteadditionalfields[propName];
                    if (field && field.QUESTION == acofferingmetadata.name) {
                        cquoteadditionalfieldsvalue = field.ANSWER;
                        break;
                    }
                }
            }
            var datatype = acofferingmetadata.dataType.id;
            content += '<div id="ai' + acofferingmetadata.id + '" class="optionWrapperOn' + (acofferingmetadata.required ? ' required' : '') + '">';
            var fieldName = 'ADDITIONALFIELD' + i;
            if (datatype == 'EF') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    cssClass: 'additionalText' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'common.updateMetadata()'
                });
            } else if (datatype == 'TA') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ta(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    rows: 4,
                    cssClass: 'additionalTA' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'common.updateMetadata()'
                });
            } else if (datatype == 'DD') {
                var ddValues = acofferingmetadata.preDefinedTextValues;
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.dd(fieldName, ddValues.list, {
                    id: cquoteadditionalfieldsvalue
                }, {
                    cssClass: 'configSelect additional' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'common.updateMetadata()'
                });
            } else if (datatype == 'DP') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    cssClass: 'additionalText datepicker' + (acofferingmetadata.required ? ' required' : ''),
                    autocomplete: 'nope',
                    onchange: 'common.updateMetadata()'
                });
            } else if (datatype == 'CB') {
                content += forms.cb(fieldName, acofferingmetadata.name, cquoteadditionalfieldsvalue, {
                    onchange: 'common.updateMetadata()'
                });
            }

            content += '</div>';
        }
        content += '</fieldset>';
        dynamic.setDivIdContent('additionalProductFields', content);

        $('.datepicker').datepicker({
            showOn: 'focus'
        });
    },
    continueClicked: function () {
        if (this.metadataIsValid()) {
            var cometRequest = this.createMetadataRequest('CONFIGURE_CONTINUE_ACTION');
            cometRequest.send();
        }
    },
    metadataIsValid: function () {
        var validator = new Validator();
        var quoteValidation = common.validation;
        quoteValidation.setValidationErrorReasons(validator);

        if (!configureCommonGlobals.REQUOTE_MODE) {
            validator.addItem(this.createMetadataValidateItem());
        }

        return validator.isValid();
    },
    updateMetadata: function () {
        // Send the comet metadata update request only for custom quote context.
        // For order entry context, metadata is sent with a continue action and suppressing it here
        // reduces the chance for synchronization errors detected at the server.
        if (configureCommonGlobals.SALES_ESTIMATE_MODE) {
            var cometRequest = this.createMetadataRequest('UPDATE_METADATA_ACTION');
            cometRequest.send();
        }
    },
    createMetadataValidateItem: function () {
        return new CustomValidateItem(null, function () {
            var cofferingmetadata = configureglobals.coffering.metadata;
            this.reason = '';
            if (cofferingmetadata != null) {
                for (var i = 0; i < cofferingmetadata.length; i++) {
                    var acofferingmetadata = cofferingmetadata[i];
                    if (acofferingmetadata.required) {
                        var datatype = acofferingmetadata.dataType.id;
                        if (datatype == 'EF' || datatype == 'DD' || datatype == 'TA' || datatype == 'DP') {
                            if (!itemHasValue(getFormItem('ADDITIONALFIELD' + i, document))) {
                                this.reason += '"' + acofferingmetadata.name + '"' + ' is required\n';
                            }
                        } else {
                            if (!isChecked('ADDITIONALFIELD' + i, document)) {
                                this.reason += '"' + acofferingmetadata.name + '"' + ' must be checked\n';
                            }
                        }
                    }
                }
            }
            return this.reason == '';
        });
    },
    createMetadataRequest: function (action) {
        this.reason = '';
        var coffering = configureglobals.coffering;

        var cometRequest = comet.newRequest(chandler, action, function (cometRequest) {
            if (cometRequest.hasAnyErrorMessages()) {
                growlMessages.showAll(cometRequest);
            } else if (action == 'CONFIGURE_CONTINUE_ACTION') {
                common.gotoNextStep();
            }
        });

        var cofferingmetadata = coffering.metadata;
        for (var i = 0, ni = cofferingmetadata ? cofferingmetadata.length : 0; i < ni; i++) {
            var acofferingmetadata = cofferingmetadata[i];
            var datatype = acofferingmetadata.dataType.id;
            if (datatype == 'EF' || datatype == 'TA' || datatype == 'DP') {
                cometRequest.addFormField('ADDITIONALFIELD' + i, false, document);
            } else if (datatype == 'CB') {
                cometRequest.addCheckBox('ADDITIONALFIELD' + i, false, document);
            } else if (datatype == 'DD') {
                cometRequest.addDropDown('ADDITIONALFIELD' + i, false, document);
            }
        }

        // cometRequest.statusDivId = 'jobQuote';
        var urlParms = getUrlParms();
        cometRequest.addParameter('reorder', urlParms.reorder);
        cometRequest.addParameter('q', urlParms.q);
        cometRequest.addParameter('r', urlParms.r);
        cometRequest.addParameter('p', urlParms.p);
        if (hasValue(configuratorGlobals.newSessionId)) {
            cometRequest.addParameter('s', configuratorGlobals.newSessionId);
        }
        if (urlParms.pai) {
            cometRequest.addParameter('pdi', decodeURIComponent(urlParms.pdi));
            cometRequest.addParameter('pai', decodeURIComponent(urlParms.pai));
            cometRequest.addParameter('pat', decodeURIComponent(urlParms.pat));
            cometRequest.addParameter('ppis', decodeURIComponent(urlParms.ppis));
        }
        return cometRequest;
    },
    gotoNextStep: function () {
        if (hasValue(configuratorGlobals.nextStepUrl)) {
            gotoURL(configuratorGlobals.nextStepUrl);
        }
    }
};
